module.exports = __webpack_public_path__ + "static/media/emma-watson.520020a1.jpg";